// -- Helpers BEGIN
const windowLoad = require("%helpers%/window-load.js");
// -- Helpers END

windowLoad(function() {
	$(".other-films-tabs__top").on("click", ".other-films-tabs__top-tab:not(.other-films-tabs__top-tab_active)", function() {
		const tabId = $(this).data("tab")
		if (!tabId) return

		$(this)
			.addClass("other-films-tabs__top-tab_active")
			.siblings()
			.removeClass("other-films-tabs__top-tab_active")
			.closest(".other-films-tabs")
			.find(".other-films-tabs__content")
			.removeClass("active")

		$(`.other-films-tabs__content[data-tab="${tabId}"]`)
			.addClass("active");
	});
});
